// removed by extract-text-webpack-plugin
module.exports = {"payNowSuccess":"payNowSuccess__payNowSuccess___3_ZT4","innerWrap":"payNowSuccess__innerWrap___1t8-B","paidCircle":"payNowSuccess__paidCircle___MtPeq","text":"payNowSuccess__text___1fEIt","thanks":"payNowSuccess__thanks___2EhPv"};


//////////////////
// WEBPACK FOOTER
// ./src/pay-now/payNowSuccess.scss
// module id = 1250
// module chunks = 0